/**
 * @deprecated since version 19.0.0
 * Please use `upToSm`, `upToMd`, `upToLg`, or `upToCustom` instead.
 * `tabletOnly` will be removed in version 20.0.0
 */
var tabletOnly = function (tablet, desktop) {
    return [tablet, tablet, tablet, desktop];
};
export default tabletOnly;
//# sourceMappingURL=tabletOnly.js.map